import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody,Button } from 'sfy-react';

import './modal.scss'
function ConfirmModal(props) {
 const {accept, showModal, closeModal, onClick } = props;

 let [otpTimer, setTimer] = useState(5);
 useEffect(()=>{
  startTimer();
 },[])
 const startTimer = () => {
  let cIntID;
  console.log(cIntID);
  cIntID = setInterval(() => {
   if (otpTimer === 1) {
    clearInterval(cIntID);
    onClick();
   }
   if (otpTimer >= 1) setTimer(otpTimer -= 1);
  }, 1000);
 }
 const onClickHere = async() => {
    if(accept) window.open("https://www.imagineonline.store/pages/thank-you", "_self");
    else window.open('https://www.imagineonline.store/pages/thank-you-1', "_self");
 }
 return (
  <Modal showModal={showModal} closeModal={closeModal} className='pwa-req-success-modal' backdropClassName='brand-pp-backdrop'>
   <ModalHeader>
    <Row >
     <Col xs={12} className='confirm-modal-header'>
      <span>{accept ?' Device Exchange Accepted' : 'Device Exchange Rejected' }
      </span>
     </Col>
    </Row>
   </ModalHeader>
   <ModalBody>
    <Row>
     <Col xs={12} style={{marginTop:'20px'}} className='confirm-modal--desc'>
      <span>You will be automatically redirected back in </span> <span className='secHilight'> {otpTimer} seconds...
      </span>
     </Col>
     <Col xs={12} style={{marginTop:'10px'}} className='confirm-modal--desc'>
      
      <span onClick={onClickHere} style={{cursor:"pointer"}} className='confirmClickHere'>Click here </span> <span>if you are not redirected automatically
      </span>
     </Col>
    </Row>
   
     
   </ModalBody>

  </Modal>
 );
}
export default ConfirmModal
